var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldSimcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.47 3.47A5.003 5.003 0 0 0 12.93 2H8C5 2 3 4 3 7v10c0 3 2 5 5 5h8c3 0 5-2 5-5v-6.93c0-1.33-.53-2.6-1.46-3.53l-3.07-3.07zM10 18.5c-1.65 0-3-1.35-3-3V15a.5.5 0 0 1 .5-.5h3.75c.14 0 .25.11.25.25V18a.5.5 0 0 1-.5.5h-1zm1.25-5H7.5A.5.5 0 0 1 7 13v-.5c0-1.65 1.35-3 3-3h1a.5.5 0 0 1 .5.5v3.25c0 .14-.11.25-.25.25zm2.75 5h-1a.5.5 0 0 1-.5-.5v-3.25c0-.14.11-.25.25-.25h3.75a.5.5 0 0 1 .5.5v.5c0 1.65-1.35 3-3 3zm-1.25-5c-.14 0-.25-.11-.25-.25V10a.5.5 0 0 1 .5-.5h1c1.65 0 3 1.35 3 3v.5a.5.5 0 0 1-.5.5h-3.75z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSimcard);
export default __webpack_public_path__ + "static/media/vuesax-bold-simcard.5a0cfb9f411c7edc8e1da3b8273a1b1c.svg";
export { ForwardRef as ReactComponent };